export const convertWeiToEth = (balance: number): number => {
    if (!balance || isNaN(Number(balance))) {
        return 0;
    }
    return Math.round(
        ((parseInt(balance?.toString() as string) / 10) ** 18) * 100
    ) / 100;
};
